module.exports = __webpack_public_path__ + "img/authority.7326df70.svg";